// Ricarica di sicurezza dopo una pubblicazione: i file del sito cambiano nome e una pagina rimasta aperta (o servita
// dalla copia salvata) cerca file che non esistono più. Al massimo una volta ogni 30 secondi, per non entrare in ciclo
// se il problema è un altro.

export function ricaricaSeVecchio(url: URL = new URL(location.href)): boolean {
  try {
    const ultima = Number(sessionStorage.getItem('arkorb-ricarica') ?? 0);
    if (Date.now() - ultima < 30_000) return false;
    sessionStorage.setItem('arkorb-ricarica', String(Date.now()));
  } catch { /* senza sessionStorage si ricarica comunque */ }
  location.assign(url.href);
  return true;
}

/** La pagina aperta è ancora l'ultima pubblicata? Confronta lo script principale con quello della pagina in rete. */
export async function versioneSuperata(): Promise<boolean> {
  const mio = document.querySelector<HTMLScriptElement>('script[type="module"][src*="/assets/index-"]')?.getAttribute('src');
  if (!mio) return false;
  try {
    const r = await fetch('/', { cache: 'no-store', headers: { Accept: 'text/html' } });
    if (!r.ok) return false;
    return !(await r.text()).includes(mio);
  } catch { return false; } // senza rete non si sa: si resta come si è
}
